import React from 'react'
import { navigate } from 'gatsby'
import * as st from '~/assets/styl/ContactModal.module.styl'
import { Button, Form, Lazyload, Link, Modal } from '~/components'
import Logo from '~/assets/svg/Logo-D-Vert.svg'
import { useContext, useLanguage } from '~/hooks'

export default function ContactModal({
  open,
  onClose,
}: {
  open: boolean
  onClose: () => void
}) {
  const { t } = useLanguage()
  const { openWhatsApp, setOpenWhatsApp } = useContext()

  const handleOpenWhatsApp = () => {
    window.open(
      'https://api.whatsapp.com/send?phone=5548998295198&text=Olá! Acabei de preencher o formulário no site e gostaria de receber mais informações sobre o empreendimento. Podemos conversar?',
      '_blank'
    )
    setOpenWhatsApp(false)
  }

  return (
    <Modal open={open} onClose={onClose} className={st.modal} lockScroll>
      {(closeProps) => (
        <>
          <button {...closeProps}></button>
          <div className={st.inner}>
            <div className={st.info}>
              <Lazyload type="img" src={Logo} width="327" height="72" />
              <h3>{t('Contact.designDetail')}</h3>
              <p>{t('Contact.contactConsultants')}</p>
              {/* <Link
                href="https://api.whatsapp.com/send?phone=5548998295198"
                external
                className={st.whatsapp}
              >
                <span className="icon-whatsapp"></span>
                {t('Contact.callWhatsApp')}
              </Link> */}
            </div>
            <Form
              path="conversions"
              idPrefix="contact-modal"
              className={st.form}
              hiddenInputs={{
                token_rdstation: '529cac2f361142d6e1232668a5dbe8f9',
                identificador: 'dvert-hotsite',
                crm_id_empreendimento: '11',
              }}
              inputs={[
                {
                  name: 'nome',
                  label: t('Contact.name'),
                },
                {
                  name: 'email',
                  label: t('Contact.email'),
                  type: 'email',
                },
                {
                  name: 'telefone',
                  label: t('Contact.phone'),
                  type: 'tel',
                  mask: 'phone',
                },
                {
                  name: 'cf_dvert_finalidade',
                  label: t('Contact.purchasePurpose'),
                  placeholder: t('Contact.select'),
                  type: 'select',
                  options: [
                    {
                      name: t('Contact.residence'),
                    },
                    {
                      name: t('Contact.investment'),
                    },
                  ],
                },
                {
                  name: 'cf_dvert_dormitorios',
                  label: t('Contact.howManyBedrooms'),
                  placeholder: t('Contact.select'),
                  type: 'select',
                  options: [
                    {
                      name: t('Contact.suites2'),
                    },
                    {
                      name: t('Contact.suites3'),
                    },
                    {
                      name: t('Contact.threeBedroomsTwoSuites'),
                    },
                  ],
                },
                {
                  name: 'privacy',
                  label: t('Contact.acceptanceStatement'),
                  type: 'checkbox',
                },
              ]}
              onSuccess={() => {
                if (openWhatsApp) handleOpenWhatsApp()
                onClose()
                navigate('/sucesso/')
              }}
              button={
                <Button className={st.btn}>{t('Contact.buttonSend')}</Button>
              }
            />
          </div>
        </>
      )}
    </Modal>
  )
}
